import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { STORE_NAMES } from './constants';

export interface FilterUIState {
  openFilterName?: string | null;
  isFilterSelectorVisible?: boolean;
  hideDialogActions?: boolean;
  dialogFitContentWidth?: boolean;
  openOverlay: (openFilterName: string) => void;
  closeOverlay: () => void;
  setFilterSelectorVisible: (isVisible: boolean) => void;
  setHideDialogActions: (isHidden: boolean) => void;
  setDialogFitContentWidth: (enabled: boolean) => void;
}
export const initialFilterUIState = {
  openFilterName: null,
  isFilterSelectorVisible: false,
};

export const useFilterUIStore = create<FilterUIState>()(
  devtools(
    (set) => ({
      ...initialFilterUIState,
      openOverlay: (openFilterName) => set(() => ({ openFilterName }), false, 'filterUI/openOverlay'),
      closeOverlay: () => set(() => ({ openFilterName: null }), false, 'filterUI/closeOverlay'),
      setFilterSelectorVisible: (isVisible) =>
        set(() => ({ isFilterSelectorVisible: isVisible }), false, 'filterUI/setFilterSelectorVisible'),
      setHideDialogActions: (isHidden) =>
        set(() => ({ hideDialogActions: isHidden }), false, 'filterUI/setHideDialogActions'),
      setDialogFitContentWidth: (enabled) =>
        set(() => ({ dialogFitContentWidth: enabled }), false, 'filterUI/setDialogFitContentWidth'),
    }),
    {
      name: STORE_NAMES.FILTERS_UI,
      enabled: process.env.NODE_ENV === 'development',
    },
  ),
);
